import React from 'react';

/**
 * PC 웹(팝업) 공유하기 리스트
 */
function ShareList() {
  return (
    <ul className="share-lst">
      <li>
        <button
          type="button"
          className="share"
          data-type="kakaotalk"
          {...{ 'tl:area': 'DDS0', 'tl:ord': '2' }}
        >
          <i className="kakaotalk">
            카카오톡 <span>공유</span>
          </i>
        </button>
      </li>
      <li>
        <button
          type="button"
          className="share"
          data-type="band"
          {...{ 'tl:area': 'DDS0', 'tl:ord': '8' }}
        >
          <i className="band">
            밴드 <span>공유</span>
          </i>
        </button>
      </li>
      <li>
        <button
          type="button"
          className="share"
          data-type="line"
          {...{ 'tl:area': 'DDS0', 'tl:ord': '5' }}
        >
          <i className="line">
            라인 <span>공유</span>
          </i>
        </button>
      </li>
      <li>
        <button
          type="button"
          className="share"
          data-type="facebook"
          {...{ 'tl:area': 'DDS0', 'tl:ord': '4' }}
        >
          <i className="facebook">
            페이스북 <span>공유</span>
          </i>
        </button>
      </li>
      <li>
        <button
          type="button"
          className="share"
          data-type="urlcopy"
          {...{ 'tl:area': 'DDS0', 'tl:ord': '6' }}
        >
          <i className="url">
            URL <span>공유</span>
          </i>
        </button>
      </li>
    </ul>
  );
}

export default ShareList;
